export default "__VITE_ASSET__CqYBwvM3__"